import { makeStyles } from '@material-ui/core/styles'

import { ChartConfig } from '../../core/types/chat.types'
import ChartRenderer from './chart-renderer'

type ChartsGridProps = {
  charts: ChartConfig[]
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'grid',
    gap: theme.spacing(2),
  },
  single: {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
  double: {
    gridTemplateColumns: 'minmax(0, 1fr)',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
  },
  multi: {
    gridTemplateColumns: 'minmax(0, 1fr)',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
  },
  item: {
    minWidth: 0,
    minHeight: 350,
    borderRadius: 12,
    border: '1px solid var(--ds-border-default, #d7dae4)',
    background: 'var(--ds-bg-surface, #ffffff)',
    padding: theme.spacing(2),
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    transition: 'background-color 160ms ease',
    '&:hover': {
      background: 'var(--ds-bg-surface-hover, rgba(241, 242, 247, 0.4))',
    },
  },
}))

const ChartsGrid = ({ charts }: ChartsGridProps) => {
  const classes = useStyles()

  const layoutClassName =
    charts.length <= 1 ? classes.single : charts.length === 2 ? classes.double : classes.multi

  return (
    <div className={`${classes.root} ${layoutClassName}`}>
      {charts.map((chart, index) => (
        <div key={`chart-${index}`} className={classes.item}>
          <ChartRenderer config={chart} />
        </div>
      ))}
    </div>
  )
}

export default ChartsGrid
